(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hedera-featured-products"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hd-featured-products')) {
  customElements.define('hd-featured-products', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.track = this.querySelector('.hdf__track');
      if (!this.track) return;
      this.abort = new AbortController();
      const options = {signal: this.abort.signal};
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.controls = this.querySelector('.hdf__controls');
      this.previous = this.querySelector('[data-step="-1"]');
      this.next = this.querySelector('[data-step="1"]');
      this.paused = false;
      this.hovered = false;
      this.visible = false;
      this.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => {
        this.move(Number(button.dataset.step));
        this.schedule();
      }, options));
      this.querySelector('[data-pause]')?.addEventListener('click', event => {
        this.paused = !this.paused;
        event.currentTarget.setAttribute('aria-pressed', String(this.paused));
        this.schedule();
      }, options);
      this.addEventListener('pointerenter', event => {if(event.pointerType === 'mouse'){this.hovered = true;this.schedule();}}, options);
      this.addEventListener('pointerleave', () => {this.hovered = false;this.schedule();}, options);
      this.addEventListener('focusin', () => this.schedule(), options);
      this.addEventListener('focusout', () => queueMicrotask(() => {if(this.isConnected)this.schedule();}), options);
      this.track.addEventListener('pointerdown', () => {this.cancelAnimation();this.dragging = true;this.schedule();}, options);
      window.addEventListener('pointerup', () => {this.dragging = false;this.schedule();}, options);
      window.addEventListener('pointercancel', () => {this.dragging = false;this.schedule();}, options);
      this.track.addEventListener('wheel', () => {this.cancelAnimation();this.schedule();}, {...options, passive:true});
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track || !this.slider()) return;
        if(event.key === 'ArrowLeft' || event.key === 'ArrowRight'){
          event.preventDefault();
          this.move(event.key === 'ArrowLeft' ? 1 : -1);
          this.schedule();
        }
      }, options);
      this.track.addEventListener('scroll', () => this.updateButtons(), {...options,passive:true});
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.reduced.addEventListener('change', () => {this.cancelAnimation();this.schedule();}, options);
      this.mobile.addEventListener('change', () => this.refresh(), options);
      this.resize = new ResizeObserver(() => this.refresh());
      this.resize.observe(this.track);
      this.observer = new IntersectionObserver(entries => {this.visible = entries[0].isIntersecting;this.schedule();}, {threshold:0.15});
      this.observer.observe(this);
      this.refresh();
    }
    slider() {return (this.mobile.matches ? this.dataset.mobile : this.dataset.desktop) === 'slider';}
    maximum() {return Math.max(0,this.track.scrollWidth - this.track.clientWidth);}
    position() {return Math.max(0,Math.min(this.maximum(),-this.track.scrollLeft));}
    updateButtons() {
      const position = this.position();
      if(this.previous) this.previous.disabled = position <= 2;
      if(this.next) this.next.disabled = position >= this.maximum() - 2;
    }
    refresh() {
      this.cancelAnimation();
      if(this.controls) this.controls.hidden = !this.slider() || this.maximum() <= 2;
      this.updateButtons();
      this.schedule();
    }
    cancelAnimation() {
      cancelAnimationFrame(this.frame);
      if(this.track) this.track.style.removeProperty('scroll-snap-type');
    }
    move(direction, wrap = false) {
      if(!this.slider()) return;
      const item = this.track.firstElementChild;
      if(!item) return;
      this.cancelAnimation();
      const start = this.position();
      const step = item.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap || 0);
      let target = Math.max(0,Math.min(this.maximum(),start + step * direction));
      if(wrap && start >= this.maximum() - 2) target = 0;
      if(this.reduced.matches){this.track.scrollLeft = -target;this.updateButtons();return;}
      const duration = Number(this.dataset.duration) || 400;
      const began = performance.now();
      this.track.style.scrollSnapType = 'none';
      const tick = now => {
        const progress = Math.min(1,(now - began)/duration);
        const eased = 1 - Math.pow(1-progress,3);
        this.track.scrollLeft = -(start+(target-start)*eased);
        if(progress<1) this.frame=requestAnimationFrame(tick);
        else {this.track.style.removeProperty('scroll-snap-type');this.updateButtons();}
      };
      this.frame=requestAnimationFrame(tick);
    }
    schedule() {
      clearTimeout(this.timer);
      if(this.dataset.autoplay !== 'true' || !this.slider() || this.maximum() <= 2 || this.paused || this.hovered || this.dragging || !this.visible || document.hidden || this.reduced.matches || this.contains(document.activeElement)) return;
      this.timer=setTimeout(() => {this.move(1,true);this.schedule();},Number(this.dataset.interval)||5000);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.cancelAnimation();
      this.abort?.abort();
      this.resize?.disconnect();
      this.observer?.disconnect();
      this.abort=null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hedera-wholesale-products"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('hd-wholesale-products')) {
  customElements.define('hd-wholesale-products', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.track = this.querySelector('.hdw__track');
      if (!this.track) return;
      this.abort = new AbortController();
      const options = {signal: this.abort.signal};
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.controls = this.querySelector('.hdw__controls');
      this.previous = this.querySelector('[data-step="-1"]');
      this.next = this.querySelector('[data-step="1"]');
      this.paused = false;
      this.hovered = false;
      this.visible = false;
      this.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => {
        this.move(Number(button.dataset.step));
        this.schedule();
      }, options));
      this.querySelector('[data-pause]')?.addEventListener('click', event => {
        this.paused = !this.paused;
        event.currentTarget.setAttribute('aria-pressed', String(this.paused));
        this.schedule();
      }, options);
      this.addEventListener('pointerenter', event => {if(event.pointerType === 'mouse'){this.hovered = true;this.schedule();}}, options);
      this.addEventListener('pointerleave', () => {this.hovered = false;this.schedule();}, options);
      this.addEventListener('focusin', () => this.schedule(), options);
      this.addEventListener('focusout', () => queueMicrotask(() => {if(this.isConnected)this.schedule();}), options);
      this.track.addEventListener('pointerdown', () => {this.cancelAnimation();this.dragging = true;this.schedule();}, options);
      window.addEventListener('pointerup', () => {this.dragging = false;this.schedule();}, options);
      window.addEventListener('pointercancel', () => {this.dragging = false;this.schedule();}, options);
      this.track.addEventListener('wheel', () => {this.cancelAnimation();this.schedule();}, {...options, passive:true});
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track || !this.slider()) return;
        if(event.key === 'ArrowLeft' || event.key === 'ArrowRight'){
          event.preventDefault();
          this.move(event.key === 'ArrowLeft' ? 1 : -1);
          this.schedule();
        }
      }, options);
      this.track.addEventListener('scroll', () => this.updateButtons(), {...options,passive:true});
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.reduced.addEventListener('change', () => {this.cancelAnimation();this.schedule();}, options);
      this.mobile.addEventListener('change', () => this.refresh(), options);
      this.resize = new ResizeObserver(() => this.refresh());
      this.resize.observe(this.track);
      this.observer = new IntersectionObserver(entries => {this.visible = entries[0].isIntersecting;this.schedule();}, {threshold:0.15});
      this.observer.observe(this);
      this.refresh();
    }
    slider() {return (this.mobile.matches ? this.dataset.mobile : this.dataset.desktop) === 'slider';}
    maximum() {return Math.max(0,this.track.scrollWidth - this.track.clientWidth);}
    position() {return Math.max(0,Math.min(this.maximum(),-this.track.scrollLeft));}
    updateButtons() {
      const position = this.position();
      if(this.previous) this.previous.disabled = position <= 2;
      if(this.next) this.next.disabled = position >= this.maximum() - 2;
    }
    refresh() {
      this.cancelAnimation();
      if(this.controls) this.controls.hidden = !this.slider() || this.maximum() <= 2;
      this.updateButtons();
      this.schedule();
    }
    cancelAnimation() {
      cancelAnimationFrame(this.frame);
      if(this.track) this.track.style.removeProperty('scroll-snap-type');
    }
    move(direction, wrap = false) {
      if(!this.slider()) return;
      const item = this.track.firstElementChild;
      if(!item) return;
      this.cancelAnimation();
      const start = this.position();
      const step = item.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap || 0);
      let target = Math.max(0,Math.min(this.maximum(),start + step * direction));
      if(wrap && start >= this.maximum() - 2) target = 0;
      if(this.reduced.matches){this.track.scrollLeft = -target;this.updateButtons();return;}
      const duration = Number(this.dataset.duration) || 400;
      const began = performance.now();
      this.track.style.scrollSnapType = 'none';
      const tick = now => {
        const progress = Math.min(1,(now - began)/duration);
        const eased = 1 - Math.pow(1-progress,3);
        this.track.scrollLeft = -(start+(target-start)*eased);
        if(progress<1) this.frame=requestAnimationFrame(tick);
        else {this.track.style.removeProperty('scroll-snap-type');this.updateButtons();}
      };
      this.frame=requestAnimationFrame(tick);
    }
    schedule() {
      clearTimeout(this.timer);
      if(this.dataset.autoplay !== 'true' || !this.slider() || this.maximum() <= 2 || this.paused || this.hovered || this.dragging || !this.visible || document.hidden || this.reduced.matches || this.contains(document.activeElement)) return;
      this.timer=setTimeout(() => {this.move(1,true);this.schedule();},Number(this.dataset.interval)||5000);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.cancelAnimation();
      this.abort?.abort();
      this.resize?.disconnect();
      this.observer?.disconnect();
      this.abort=null;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hedera_solution_path"] && !Shopify.designMode) return;
  try {
    
  function initializeHederaSolutionPath(root) {
    if (!root || root.dataset.hdcPathReady === 'true') return;

    const track = root.querySelector('[data-hdc-path-track]');
    const controls = root.querySelector('[data-hdc-path-controls]');
    const previousButton = root.querySelector('[data-hdc-path-previous]');
    const nextButton = root.querySelector('[data-hdc-path-next]');
    const status = root.querySelector('[data-hdc-path-status]');
    const slides = Array.from(root.querySelectorAll('.hdc-section-head, .hdc-step, .hdc-path__product, .hdc-solution-collection-card')).filter((slide) => slide.closest('[data-hdc-path-track]') === track);

    if (!track || !controls || slides.length === 0) return;

    root.dataset.hdcPathReady = 'true';
    let activeIndex = 0;
    let frame;

    const updateControls = () => {
      const trackRect = track.getBoundingClientRect();
      const inlineStart = getComputedStyle(track).direction === 'rtl' ? 'right' : 'left';
      let closestDistance = Infinity;

      slides.forEach((slide, index) => {
        const slideRect = slide.getBoundingClientRect();
        const distance = Math.abs(slideRect[inlineStart] - trackRect[inlineStart]);
        if (distance < closestDistance) {
          closestDistance = distance;
          activeIndex = index;
        }
      });

      status.textContent = `${activeIndex + 1} / ${slides.length}`;
      previousButton.disabled = activeIndex === 0;
      nextButton.disabled = activeIndex === slides.length - 1;
      controls.hidden = slides.length < 2;
    };

    const goToSlide = (index) => {
      const targetIndex = Math.max(0, Math.min(index, slides.length - 1));
      slides[targetIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    };

    previousButton.addEventListener('click', () => goToSlide(activeIndex - 1));
    nextButton.addEventListener('click', () => goToSlide(activeIndex + 1));
    track.addEventListener('scroll', () => {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(updateControls);
    }, { passive: true });
    window.addEventListener('resize', updateControls, { passive: true });
    updateControls();
  }

  function initializeAllHederaSolutionPaths(scope) {
    const context = scope || document;
    context.querySelectorAll('[data-hdc-path-slider]').forEach(initializeHederaSolutionPath);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAllHederaSolutionPaths(document), { once: true });
  } else {
    initializeAllHederaSolutionPaths(document);
  }

  document.addEventListener('shopify:section:load', (event) => initializeAllHederaSolutionPaths(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hedera_subcollections"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hedera-subcollections')) {
  customElements.define('hedera-subcollections', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.list = this.querySelector('.hd-subcollections__list');
      if (!this.list) return;
      this.cards = [...this.list.querySelectorAll('.hd-subcollections__card')];
      this.controls = this.querySelector('.hd-subcollections__controls');
      this.previous = this.querySelector('[data-previous]');
      this.next = this.querySelector('[data-next]');
      this.pause = this.querySelector('[data-pause]');
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.mobile = matchMedia('(max-width: 749px)');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.hovered = false;
      this.focused = false;
      this.userPaused = false;
      this.suppressClick = false;
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.pause.addEventListener('click', () => {
        this.userPaused = !this.userPaused;
        this.pause.setAttribute('aria-pressed', String(this.userPaused));
        this.schedule();
      }, options);
      this.addEventListener('pointerenter', (event) => {
        if (event.pointerType !== 'touch') { this.hovered = true; this.schedule(); }
      }, options);
      this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
      this.addEventListener('focusout', (event) => {
        this.focused = this.contains(event.relatedTarget);
        this.schedule();
      }, options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.stopAnimation();
        this.schedule();
      }, options);
      this.mobile.addEventListener('change', () => this.refresh(), options);
      this.reduced.addEventListener('change', () => this.refresh(), options);
      this.list.addEventListener('scroll', () => this.updateControls(), { ...options, passive: true });
      this.list.addEventListener('wheel', () => this.stopAnimation(), { ...options, passive: true });
      this.list.addEventListener('keydown', (event) => {
        if (!this.active || event.altKey || event.ctrlKey || event.metaKey) return;
        const rtl = getComputedStyle(this).direction === 'rtl';
        const direction = event.key === 'ArrowRight' ? (rtl ? -1 : 1) : event.key === 'ArrowLeft' ? (rtl ? 1 : -1) : 0;
        if (direction) { event.preventDefault(); this.move(direction); }
      }, options);
      this.list.addEventListener('pointerdown', (event) => {
        this.suppressClick = false;
        if (!this.active) return;
        this.stopAnimation();
        if (this.dataset.swipe !== 'true' || event.button !== 0) return;
        this.drag = { id: event.pointerId, x: event.clientX, start: this.list.scrollLeft, mouse: event.pointerType === 'mouse' };
        this.schedule();
      }, options);
      this.list.addEventListener('pointermove', (event) => {
        if (!this.drag || !this.drag.mouse || this.drag.id !== event.pointerId) return;
        const distance = event.clientX - this.drag.x;
        if (Math.abs(distance) < 6 && !this.suppressClick) return;
        this.suppressClick = true;
        this.list.dataset.dragging = '';
        this.list.setPointerCapture(event.pointerId);
        event.preventDefault();
        this.list.scrollLeft = this.drag.start - distance;
      }, options);
      const endDrag = (event) => {
        if (!this.drag || this.drag.id !== event.pointerId) return;
        const snap = this.suppressClick && this.drag.mouse;
        this.drag = null;
        delete this.list.dataset.dragging;
        if (this.list.hasPointerCapture(event.pointerId)) this.list.releasePointerCapture(event.pointerId);
        if (snap) this.scrollToCard(this.nearest());
        this.schedule();
      };
      window.addEventListener('pointerup', endDrag, options);
      window.addEventListener('pointercancel', endDrag, options);
      this.list.addEventListener('lostpointercapture', endDrag, options);
      this.list.addEventListener('dragstart', (event) => {
        if (this.active && this.dataset.swipe === 'true') event.preventDefault();
      }, options);
      this.list.addEventListener('click', (event) => {
        if (this.suppressClick) { event.preventDefault(); event.stopPropagation(); this.suppressClick = false; }
      }, { ...options, capture: true });
      this.addEventListener('shopify:block:select', (event) => {
        const index = this.cards.findIndex(card => card === event.target || card.contains(event.target));
        if (index >= 0 && this.active) this.scrollToCard(index);
      }, options);
      this.resizeObserver = new ResizeObserver(() => this.refresh());
      this.resizeObserver.observe(this.list);
      this.refresh();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.resizeObserver?.disconnect();
      clearTimeout(this.timer);
      this.stopAnimation();
    }
    refresh() {
      this.stopAnimation();
      this.active = this.mobile.matches ? this.dataset.mobileLayout === 'rail' : this.dataset.desktopLayout === 'slider';
      if (!this.active) this.list.scrollLeft = 0;
      this.updateControls();
      this.schedule();
    }
    edges() {
      const rtl = getComputedStyle(this).direction === 'rtl';
      const viewport = this.list.getBoundingClientRect();
      const first = this.cards[0].getBoundingClientRect();
      const last = this.cards[this.cards.length - 1].getBoundingClientRect();
      return {
        start: rtl ? first.right <= viewport.right + 2 : first.left >= viewport.left - 2,
        end: rtl ? last.left >= viewport.left - 2 : last.right <= viewport.right + 2
      };
    }
    updateControls() {
      const overflow = this.active && this.list.scrollWidth > this.list.clientWidth + 2;
      const arrows = this.mobile.matches ? this.dataset.mobileArrows === 'true' : this.dataset.arrows === 'true';
      const autoplay = this.dataset.autoplay === 'true' && !this.reduced.matches && !window.Shopify?.designMode;
      const showArrows = overflow && (arrows || this.dataset.swipe !== 'true');
      this.controls.hidden = !overflow || (!showArrows && !autoplay);
      this.previous.hidden = this.next.hidden = !showArrows;
      this.pause.hidden = !overflow || !autoplay;
      const edges = this.edges();
      this.previous.disabled = !overflow || edges.start;
      this.next.disabled = !overflow || edges.end;
    }
    nearest() {
      const rtl = getComputedStyle(this).direction === 'rtl';
      const edge = rtl ? 'right' : 'left';
      const start = this.list.getBoundingClientRect()[edge];
      let nearest = 0;
      let distance = Infinity;
      this.cards.forEach((card, index) => {
        const nextDistance = Math.abs(card.getBoundingClientRect()[edge] - start);
        if (nextDistance < distance) { nearest = index; distance = nextDistance; }
      });
      return nearest;
    }
    move(direction, wrap = false) {
      if (!this.active) return;
      const edges = this.edges();
      if ((direction > 0 && edges.end) || (direction < 0 && edges.start)) {
        if (wrap) this.scrollToCard(direction > 0 ? 0 : this.cards.length - 1);
        return;
      }
      this.scrollToCard(Math.max(0, Math.min(this.cards.length - 1, this.nearest() + direction)));
    }
    stopAnimation() {
      cancelAnimationFrame(this.frame);
      if (this.list) delete this.list.dataset.animating;
    }
    scrollToCard(index) {
      this.stopAnimation();
      const rtl = getComputedStyle(this).direction === 'rtl';
      const edge = rtl ? 'right' : 'left';
      const delta = this.cards[index].getBoundingClientRect()[edge] - this.list.getBoundingClientRect()[edge];
      const start = this.list.scrollLeft;
      const max = this.list.scrollWidth - this.list.clientWidth;
      const end = rtl ? Math.max(-max, Math.min(0, start + delta)) : Math.max(0, Math.min(max, start + delta));
      const duration = this.reduced.matches ? 0 : Number(this.dataset.duration) || 0;
      if (!duration || Math.abs(end - start) < 1) { this.list.scrollLeft = end; this.updateControls(); return; }
      this.list.dataset.animating = '';
      const began = performance.now();
      const animate = (now) => {
        const progress = Math.min(1, (now - began) / duration);
        const eased = 1 - Math.pow(1 - progress, 3);
        this.list.scrollLeft = start + (end - start) * eased;
        if (progress < 1) this.frame = requestAnimationFrame(animate);
        else { delete this.list.dataset.animating; this.updateControls(); }
      };
      this.frame = requestAnimationFrame(animate);
    }
    schedule() {
      clearTimeout(this.timer);
      if (!this.active || this.dataset.autoplay !== 'true' || this.reduced.matches || this.userPaused || this.hovered || this.focused || this.drag || document.hidden || window.Shopify?.designMode || this.list.scrollWidth <= this.list.clientWidth + 2) return;
      this.timer = setTimeout(() => { this.move(1, true); this.schedule(); }, Math.max(2000, Number(this.dataset.interval) || 5000));
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }
  customElements.define('cart-note', CartNote);
	



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;

            const recommendations = html.querySelector('[grid-recommendation]');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.querySelector('[grid-recommendation]').innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
